// extracted by mini-css-extract-plugin
export default {"tdFonte1":"ClienteVersoes_tdFonte1__vlXlS","tdFonte2":"ClienteVersoes_tdFonte2__aLZVN"};